// extracted by mini-css-extract-plugin
export default {"guidelineIcon":"GuidelineChip_guidelineIcon__xjE9l","guidelineChip":"GuidelineChip_guidelineChip__0cxaV"};